import {ReaderService} from "../services/ReaderService";
import {Reader} from "../entities/Reader";
import {QueuedCommand} from "../entities/QueuedCommand";
import {CommandManager} from "../libs/CommandManager";

export class CommandSetSecurityCtrl {
    commandEnabled:boolean = false;
    readers:Reader[];
    selectedReader:Reader;
    SECURITYMODEON = "On";
    SECURITYMODEOFF = "Off";
    SECURITYMODESNOOP = "Snoop";
    securityModes:string[] = [this.SECURITYMODEON,this.SECURITYMODEOFF,this.SECURITYMODESNOOP];
    selectedSecurityMode = this.SECURITYMODEOFF;
    thresholdDbm:number = -150;
    static $inject = ['CommandManager','ReaderService'];
    constructor(public commandManager:CommandManager, public readerService:ReaderService) {
        this.readerService.getGateways().then((data)=>{
            this.readers = data;
            if(data.length > 0)
                this.selectedReader = data[0];
        })
    }
    runCommand(){
        var queuedCommand = new QueuedCommand(null,null,"Set Security",this.selectedSecurityMode+":"+this.thresholdDbm+":"+this.selectedReader.name,this.selectedReader.id);
        this.commandManager.runCommands([queuedCommand]);
    }
}


export class CommandSetSecurityDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdsetsecurity.html').default;
    scope = {
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandSetSecurityCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandSetSecurityDirective();
        }
        return directive;
    }
}
